export const isUpdateRequired = (currentVersion: string, minimumVersion: string): boolean => {
  // Normalize versions by padding with zeros (e.g., "1.3" becomes "1.3.0")
  const normalizeVersion = (version: string): number[] => {
    return version
      .split('.')
      .map((part) => parseInt(part, 10) || 0)
      .concat([0, 0, 0]) // Ensure at least 3 parts
      .slice(0, 3) // Take only first 3 parts
  }

  const current = normalizeVersion(currentVersion)
  const minimum = normalizeVersion(minimumVersion)

  // Compare version parts
  for (let i = 0; i < 3; i++) {
    if (current[i] < minimum[i]) {
      return true // Update required
    }
    if (current[i] > minimum[i]) {
      return false // Current version is newer, no update needed
    }
  }

  // Versions are equal
  return false
}

